<div class="logo-header">
  @if (settings?.logoImage !== "user-photos/food-portal-logos/") {
    <img class="logo" src="{{ storageUrl }}/{{ settings?.logoImage }}" />
  }
  <span (click)="openMenu()" class="btn menu">
    <span class="icon-burger-thin"></span>
  </span>
</div>

<div class="search-options">
  <span class="search-input">
    <svg class="mag-icon" height="24" width="24" viewBox="0 0 24 24" role="presentation" focusable="false">
      <path
        d="M10.5 17C14.0841 17 17 14.0841 17 10.5C17 6.91592 14.0841 4 10.5 4C6.91592 4 4 6.91592 4 10.5C4 14.0841 6.91592 17 10.5 17ZM10.5 2C15.1944 2 19 5.80558 19 10.5C19 12.3368 18.4173 14.0374 17.4268 15.4273L22 20.0049L20.0049 22L15.4272 17.4269C14.0373 18.4173 12.3368 19 10.5 19C5.80558 19 2 15.1944 2 10.5C2 5.80558 5.80558 2 10.5 2Z"></path>
    </svg>

    <input
      class="n-tb"
      type="text"
      placeholder="Search..."
      [ngModel]="searchText"
      (ngModelChange)="searchTerms$.next($event)"
      (focus)="searchInputFocus($event)" />

    @if (searchText) {
      <span class="icon-status-cross clear-search btn" (click)="clearSearchText()"></span>
    }
  </span>

  <button
    class="allergies btn"
    [ngClass]="{ 'allergen-count': selectedAllergenCount() > 0 }"
    (click)="openAllergenMenu()">
    <span class="icon-beans"></span>
    <span>{{ selectedAllergies() }}</span>
  </button>
</div>

@if (resultsMode === "default") {
  <div class="results">
    @if (navItems) {
      <nav
        #navItemsElement
        class="draggable-container"
        (mousedown)="startNavDrag($event)"
        (mouseup)="stopNavDrag()"
        (touchstart)="startTouchDrag($event)">
        <ul class="swiper" [ngStyle]="{ transform: 'translateX(' + navOffsetX + 'px)' }">
          @for (ni of navItems; track ni; let i = $index) {
            <li #navItemElement (click)="selectNavItem(ni, i)" [class.selected]="selectedNavItem === ni">
              {{ ni.name }}
            </li>
          }
        </ul>
      </nav>
    }

    <div class="recipe-groups" #recipeGroupsContainer>
      @for (recipeGroup of recipeGroups; track recipeGroup) {
        <div class="recipe-group" [attr.data-group-id]="recipeGroup.id">
          @if (showGroupTitles) {
            <div class="recipe-group-label" #recipeGroupLabel>
              {{ recipeGroup.label }}
            </div>
          }

          <div class="recipe-list" #recipes>
            @for (recipe of recipeGroup.recipes; track recipe) {
              <pi-recipe-card
                [recipe]="recipe"
                class="item btn"
                [routerLink]="['./recipe', recipe.id]"
                [class.no-photos]="settings.disableRecipePhotos" />
            }
          </div>
        </div>
      }
    </div>
  </div>
}

@if (settings) {
  <pi-allergies-menu #AllergenMenu [settings]="settings" />
}

@if (resultsMode === "searchResults") {
  <div class="search-results recipe-list">
    @for (recipe of searchResults; track recipe) {
      <pi-recipe-card
        [recipe]="recipe"
        class="item btn"
        [routerLink]="['./recipe', recipe.id]"
        [class.no-photos]="settings.disableRecipePhotos" />
    }
  </div>
}
